module.exports = "### JSX\n\n- After XHP released\n\n- Adam Hupp\n\n- XHP-like concept for JS\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/07_jsx/notes_1.md
// module id = 1499
// module chunks = 0